import { Popover, useUiKitContext } from '@lmc/ui-kit'
import Dot from '@lmc/ui-kit/src/legacy/atoms/Dot/Dot'
import {
  type DotStatus,
  type DotType,
  dotsTypes
} from '@lmc/ui-kit/src/legacy/molecules/Legend/Legend'
import styled from 'styled-components'

export type DotCellProps = {
  /**
   * @default 'notValid'
   */
  dotStatus: DotStatus
  lastRefreshed?: string
  dueForRefresh?: string
  title: string
  trainingRequired: boolean
}

const DotWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Line = styled.div``
const NoExpireLine = styled.div`
  color: ${({ theme }) => theme.palette.silver};

  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`
const Span = styled.span``

export const getColourDot = (status: DotStatus) => {
  let returnedDot = {} as DotType

  dotsTypes.forEach((dot) => {
    if (dot.key === status) {
      returnedDot = dot
    }
  })

  return returnedDot
}

function DotCell(props: DotCellProps) {
  const {
    lastRefreshed,
    dueForRefresh,
    dotStatus = 'notValid',
    title,
    trainingRequired
  } = props
  const { translation: t } = useUiKitContext()

  const renderNoExpire =
    dotStatus === 'valid' && !dueForRefresh && trainingRequired

  return (
    <DotWrapper>
      <Popover
        trigger="hover"
        title={title}
        content={
          <>
            {lastRefreshed && (
              <Line>
                {t(`skillsAndNeeds.table.lastRefreshed`)}:{' '}
                <Span>{lastRefreshed}</Span>
              </Line>
            )}
            {dueForRefresh && (
              <Line>
                {t('skillsAndNeeds.table.dueForRefresh')}:{' '}
                <Span>{dueForRefresh}</Span>
              </Line>
            )}
            {renderNoExpire && (
              <NoExpireLine>{t('skillsAndNeeds.table.noExpire')}</NoExpireLine>
            )}
          </>
        }
      >
        <Dot {...getColourDot(dotStatus)} />
      </Popover>
    </DotWrapper>
  )
}

export default DotCell
